import { useEffect, useRef } from 'react';
import { useDialogs } from '@/components/dialogs/hooks';
import { Modals } from '@/helpers/modals';

// Visitors who dismiss the registration modal without signing up land on the
// final offer instead of staying stuck mid-flow.
export const useFinalOfferOnRegModalClose = (onModalClose: () => void) => {
  const { modal } = useDialogs();
  const isRegModalOpen = modal === Modals.Registration;
  const wasOpenRef = useRef(false);
  // Read through a ref so a fresh onModalClose identity each render doesn't
  // force this to re-run for reasons unrelated to the modal actually closing.
  const onModalCloseRef = useRef(onModalClose);
  onModalCloseRef.current = onModalClose;

  useEffect(() => {
    if (wasOpenRef.current && !isRegModalOpen) onModalCloseRef.current();
    wasOpenRef.current = isRegModalOpen;
  }, [isRegModalOpen]);
};
